module.exports = __webpack_public_path__ + "static/media/image_reupload_avatar.7f187654.svg";